/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1903132710 — ServiceFail */

import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';

import { useAppStore } from '../../../../shared/hooks/useAppStore';
import { ContentBox, PrimaryButton, ScreenTitle, ScreenWrapper } from '../../../../shared/ui';
import { AnimatedIcon } from '../../../../shared/ui/AnimatedIcon/AnimatedIcon';
import crossAnimation from '../../../../shared/ui/AnimatedIcon/animations/cross.json';
import { SERVICE_ROUTES } from '../../service.constants';

import styles from './ServiceFail.module.css';

export const ServiceFail = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { qr: qrId } = useAppStore((s) => s.vm);

    const navigateToRobotPage = (): void => {
        navigate(generatePath(SERVICE_ROUTES.robot, { id: qrId }), {
            replace: true,
        });
    };
    const navigateToMainPage = (): void => {
        navigate(generatePath(SERVICE_ROUTES.main, { id: qrId }), {
            replace: true,
        });
    };

    return (
        <ScreenWrapper>
            <ScreenTitle>{t('Fail check')} </ScreenTitle>

            <ContentBox className={styles.animationWrapper}>
                <AnimatedIcon loop={false} animationData={crossAnimation} />
            </ContentBox>
            <PrimaryButton onClick={navigateToRobotPage}>
                {t('Try')}
            </PrimaryButton>
            <PrimaryButton onClick={navigateToMainPage}>
                {t('Main page')}
            </PrimaryButton>
        </ScreenWrapper>
    );
};
